import { Link } from 'react-router-dom'
import { Sparkles, Twitter, Github, Linkedin, Mail } from 'lucide-react'

const footerLinks = {
    Product: [
        { name: 'Features', href: '#features' },
        { name: 'Pricing', href: '#pricing' },
        { name: 'Chrome Extension', href: 'https://chromewebstore.google.com/detail/inkspot-ai-writing-assist/bjifgkinjedaikncmccpihmclmehhmoo' },
        { name: 'Web App', href: '/app' },
        { name: 'API', href: '#' },
    ],
    Resources: [
        { name: 'Newsletter', href: '/newsletter' },
        { name: 'Documentation', href: '#' },
        { name: 'Blog', href: '#' },
        { name: 'Writing Tips', href: '#' },
        { name: 'Cliché Dictionary', href: '#' },
    ],
    Company: [
        { name: 'About', href: '#' },
        { name: 'Careers', href: '#' },
        { name: 'Contact', href: 'mailto:support@inkspot.icu' },
        { name: 'Press Kit', href: '#' },
    ],
    Legal: [
        { name: 'Privacy Policy', href: '#' },
        { name: 'Terms of Service', href: '#' },
        { name: 'Cookie Policy', href: '#' },
        { name: 'GDPR', href: '#' },
    ],
}

const socialLinks = [
    { name: 'Twitter', icon: Twitter, href: 'https://twitter.com/inkspotapp' },
    { name: 'GitHub', icon: Github, href: 'https://github.com/inkspot' },
    { name: 'LinkedIn', icon: Linkedin, href: 'https://linkedin.com/company/inkspot' },
    { name: 'Email', icon: Mail, href: 'mailto:support@inkspot.icu' },
]

export default function Footer() {
    const currentYear = new Date().getFullYear()

    return (
        <footer className="relative bg-slate-950 border-t border-white/10">
            {/* Main Footer */}
            <div className="section-container py-16">
                <div className="grid grid-cols-2 md:grid-cols-6 gap-8 lg:gap-12">
                    {/* Brand Column */}
                    <div className="col-span-2">
                        <Link to="/" className="flex items-center gap-2 mb-4">
                            <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-primary-400 to-accent-500 flex items-center justify-center">
                                <Sparkles className="w-6 h-6 text-white" />
                            </div>
                            <span className="text-xl font-bold text-white">InkSpot</span>
                        </Link>
                        <p className="text-white/50 text-sm leading-relaxed mb-6 max-w-xs">
                            AI-powered cliché detection for writers who want their words to stand out.
                            Write better, cut the clichés.
                        </p>

                        {/* Social Links */}
                        <div className="flex gap-3">
                            {socialLinks.map((social) => (
                                <a
                                    key={social.name}
                                    href={social.href}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="w-10 h-10 rounded-lg bg-white/5 hover:bg-white/10 
                           flex items-center justify-center text-white/50 hover:text-white
                           transition-all duration-200"
                                    aria-label={social.name}
                                >
                                    <social.icon className="w-5 h-5" />
                                </a>
                            ))}
                        </div>
                    </div>

                    {/* Link Columns */}
                    {Object.entries(footerLinks).map(([title, links]) => (
                        <div key={title}>
                            <h3 className="font-semibold text-white mb-4">{title}</h3>
                            <ul className="space-y-3">
                                {links.map((link) => (
                                    <li key={link.name}>
                                        {link.href.startsWith('#') || link.href.startsWith('mailto') ? (
                                            <a
                                                href={link.href}
                                                className="text-sm text-white/50 hover:text-white transition-colors"
                                            >
                                                {link.name}
                                            </a>
                                        ) : (
                                            <Link
                                                to={link.href}
                                                className="text-sm text-white/50 hover:text-white transition-colors"
                                            >
                                                {link.name}
                                            </Link>
                                        )}
                                    </li>
                                ))}
                            </ul>
                        </div>
                    ))}
                </div>
            </div>

            {/* Bottom Bar */}
            <div className="border-t border-white/10">
                <div className="section-container py-6 flex flex-col sm:flex-row items-center justify-between gap-4">
                    <p className="text-sm text-white/60">
                        © {currentYear} InkSpot. All rights reserved.
                    </p>
                    <div className="flex items-center gap-6">
                        <span className="text-sm text-white/60">
                            Made with 💜 for writers everywhere
                        </span>
                    </div>
                </div>
            </div>
        </footer>
    )
}
